import type { BookingCancelScheduleResponse } from "wagAPI";
import type { BookingCancelScheduleParsedResponse } from "webApp";
export const bookingCancelScheduleResponseParser = (response: BookingCancelScheduleResponse): BookingCancelScheduleParsedResponse => ({ ...response,
  cancelFee: response.cancel_fee,
  secondsLeftToReschedule: response.seconds_left_to_reschedule,
  hasCancelFee: response.has_cancel_fee,
  isEligibleForWaivedCancelFee: response.is_eligible_for_waived_cancel_fee
});
export default bookingCancelScheduleResponseParser;